document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.accessibility-menu-wrapper');
  const btn = wrapper.querySelector('.btn--accessibility');
  const menu = document.querySelector('.accessibility-menu');

  function isMenuOpen() {
    return wrapper.classList.contains('is-menu-open') === true;
  }

  btn.addEventListener('click', (e) => {
    wrapper.classList.toggle('is-menu-open');
    menu.setAttribute('aria-hidden', String(!isMenuOpen()));
    menu.hidden = !isMenuOpen();
  });
});
